import React from 'react';
import Header from '../components/header';
import Footer from '../components/footer';

export default function NoPage() {
  return (
    <>
    <Header/>
    <section className="h_70vh py-5 d-flex flex-column justify-content-center align-items-center">
        <h1 className='mb-3'>Sorry It's page not found maybe coming soon.</h1>
        <a href="/" className='default_btn fs_12'>Back to Home</a>
    </section>
    <Footer/>
    </>
  )
}
